import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cartSlice, CartState, StoreState } from '../../../redux';
import { Route } from '../../../../enums';
import { useRouter } from 'next/router';

type ClearCartEffectReturn = {
  clearCart: () => void;
};

export const useClearCartEffect = (route: Route): ClearCartEffectReturn => {
  const dispatch = useDispatch();
  const router = useRouter();

  const cartState = useSelector(
    (state: StoreState) => state.orders.cart
  ) as CartState;

  useEffect(() => {
    if (cartState.cart === null) {
      router.push(route as string);
    }
  }, [cartState, router]);

  const clearCart = (): void => {
    dispatch(cartSlice.actions.clearCart());
  };

  return { clearCart };
};
